<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
	.dm_overlay{
		position: fixed;
		top: 0;
		left: 0;
		z-index: 1;
		width: 100%;
		height: 100%;
		    /* background-color: rgba(0, 0, 0, 0) !important; */
	}
	/* .van-overlay {
	    background-color: rgba(0, 0, 0, 0) !important;
	} */
	.van-popup{
		background-color: rgba(0, 0, 0, 0) !important;
	}
</style>